export default __webpack_public_path__ + "static/media/aave.5a0c0d88.svg";